/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// RGBARRY-CUSTOMIZATION: free-shipping ($100 shipping100 promo) helpers. Kept in this non-component
// module so the .tsx banner and the Order Summary shipping line share one source of truth without
// exporting non-components from a component file (react-refresh / only-export-components).

import type { OrderSummaryBasket } from '@/components/order-summary';

export const FREE_SHIPPING_THRESHOLD = 100;

/**
 * True when the cart's merchandise subtotal has reached the free-shipping threshold. At that point
 * free standard shipping is guaranteed regardless of whether the shipping promo has been applied to
 * the basket yet — no shipping address or method is needed to know this. Kept here so the progress
 * banner and the Order Summary shipping line stay in agreement.
 */
export function isFreeShippingQualified(basket: OrderSummaryBasket): boolean {
    return (basket.productSubTotal ?? 0) >= FREE_SHIPPING_THRESHOLD;
}
